<template>
  <v-dialog
      v-model="dialog"
      max-width="600px"
  >
    <v-card>
        <v-card-title>
          {{ formTitle }}
        </v-card-title>

        <v-card-text class="dialog-v-text-scrollable">
          <v-alert
              v-if="errorAlert"
              type="error"
              outlined
              transition="scale-transition"
              class="mt-2"
          >
            {{ errorMessage }}
          </v-alert>

          <v-container>
            <v-row>
              <v-col
                  v-show="isNew"
                  cols="12"
                  sm="12"
                  md="12"
              >
                <v-autocomplete
                    key="medication"
                    v-model="medication.medication"
                    v-validate="{ required: true}"
                    name="medication"
                    label="Medication"
                    :items="availableMedications"
                    :error-messages="errors.collect('medication')"
                    item-value="code"
                    item-text="label"
                ></v-autocomplete>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="6"
              >
                <v-select
                    v-model="medication.routes"
                    label="Routes"
                    multiple
                    chips
                    deletable-chips
                    :items="routesItems"
                    item-value="code"
                    item-text="label"
                ></v-select>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="6"
              >
                <v-checkbox
                    v-model="medication.allowOtherRoutes"
                    label="Allow Other Routes"
                ></v-checkbox>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="6"
              >
                <v-select
                    v-model="medication.doseUnits"
                    multiple
                    chips
                    deletable-chips
                    label="Dose Units"
                    :items="availableDoseUnits"
                    item-value="code"
                    item-text="label"
                ></v-select>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="6"
              >
                <v-checkbox
                    v-model="medication.allowOtherUnits"
                    label="Allow Other Units"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
              v-if="!isNew"
              text
              color="primary"
              @click="deleteItem"
          >
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              text
              color="blue darken-1"
              @click="close"
          >
            Cancel
          </v-btn>
          <v-btn
              :loading="saving"
              color="primary"
              @click="saveMedication"
          >
            Save
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import medsSuggestedRoutes from '@/api/medsSuggestedRoutes';
import _ from 'lodash';
import errorAlertMixins from '@/mixins/errorAlertMixins';

export default {
  name: 'EditMedicationDialog',
  mixins: [errorAlertMixins],
  props: {
    medications: {
      type: Array,
      required: true,
    },
    availableMedications: {
      type: Array,
      required: true,
    },
    availableRoutes: {
      type: Array,
      required: true,
    },
    availableDoseUnits: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      isNew: true,
      saving: false,
      medication: {
        id: null,
        medication: null,
        routes: [],
        allowOtherRoutes: false,
        doseUnits: [],
        allowOtherUnits: false,
      },
      dictionary: {
        attributes: {
          medication: 'Medication',
        },
      },
    };
  },
  computed: {
    formTitle() {
      return this.isNew ? 'New Item' : `Edit: ${this.medication.medicationName}`;
    },
    routesItems() {
      const onlyOxyRoutes = [
        'NRB', 'BVM', 'CPAP', 'NC',
      ];
      const oxyRoutes = onlyOxyRoutes.concat(['IN', 'IH']);
      if (this.medication.medication === 'OXY') {
        return this.availableRoutes.filter(item => oxyRoutes.includes(item.code));
      }
      return this.availableRoutes.filter(item => !onlyOxyRoutes.includes(item.code));
    },
  },

  methods: {
    async show(medication = null) {
      this.hideError();
      await this.$validator.reset();
      this.$validator.pause();

      if (medication) {
        this.isNew = false;
        this.medication = _.cloneDeep(medication);
      } else {
        this.isNew = true;
        this.medication = {
          id: null,
          medication: null,
          routes: [],
          allowOtherRoutes: false,
          doseUnits: [],
          allowOtherUnits: false,
        };
      }
      this.dialog = true;
      this.$validator.resume();
    },
    close() {
      this.dialog = false;
    },
    deleteItem() {
      this.$emit('deleteItem', this.medication);
    },
    async saveMedication() {
      this.hideError();
      await this.$validator.reset();
      if (!await this.$validator.validateAll()) {
        return;
      }

      try {
        this.saving = true;

        if (this.isNew) {
          await medsSuggestedRoutes.createMedication(this.medication);
        } else {
          await medsSuggestedRoutes.updateMedication(this.medication.id, this.medication);
        }
        this.$emit('saved');
        this.close();
      } catch (e) {
        this.parseErrorResponse(e.response, true);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
